import type { CSSProperties } from 'react';
import { useId } from 'react';

import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type IconExpenseSplitProps = IconComponentBaseProps & {
  fill?: string;
};

export const IconExpenseSplit = ({
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
  className,
}: IconExpenseSplitProps) => {
  const maskId = useId();
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="24" height="24" rx="12" fill="#E5E9F0" />
      <mask id={maskId} style={maskStyle} maskUnits="userSpaceOnUse" x="3" y="3" width="18" height="18">
        <rect x="3" y="3" width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M10.3259 9.06896C9.86265 8.60563 9.63098 8.04639 9.63098 7.39125C9.63089 6.7362 9.86256 6.17697 10.326 5.71356C10.7893 5.25023 11.3485 5.01855 12.0037 5.01855C12.6587 5.01864 13.2179 5.25036 13.6812 5.71368C14.1446 6.17702 14.3763 6.7362 14.3764 7.39125C14.3764 8.04639 14.1447 8.60563 13.6814 9.06896C13.218 9.53237 12.6587 9.76404 12.0037 9.76395C11.3485 9.76395 10.7893 9.53229 10.3259 9.06896ZM11.1212 8.27319C11.3661 8.51811 11.6602 8.64066 12.0033 8.64084C12.3465 8.64111 12.6406 8.51877 12.8855 8.27385C13.1305 8.02884 13.2531 7.73478 13.2533 7.39166C13.2535 7.04853 13.131 6.75446 12.886 6.50945C12.6411 6.26453 12.347 6.14193 12.0038 6.14166C11.6607 6.14148 11.3666 6.26387 11.1217 6.50879C10.8767 6.7538 10.7541 7.04787 10.7539 7.391C10.7538 7.73413 10.8762 8.02818 11.1212 8.27319ZM10.3259 18.2784C9.86256 17.815 9.63089 17.2558 9.63098 16.6007C9.63098 15.9456 9.86265 15.3864 10.3259 14.923C10.7893 14.4597 11.3485 14.228 12.0037 14.228C12.6587 14.2279 13.218 14.4596 13.6814 14.923C14.1447 15.3864 14.3764 15.9456 14.3764 16.6007C14.3763 17.2558 14.1446 17.8149 13.6812 18.2783C13.2179 18.7416 12.6587 18.9734 12.0037 18.9734C11.3485 18.9734 10.7893 18.7418 10.3259 18.2784ZM11.1211 17.4825C11.3661 17.7275 11.6602 17.8502 12.0033 17.8503C12.3464 17.8505 12.6405 17.7281 12.8855 17.4831C13.1304 17.2382 13.2531 16.9442 13.2533 16.601C13.2536 16.2578 13.1311 15.9638 12.8861 15.7188C12.6411 15.4737 12.3471 15.3511 12.0039 15.351C11.6608 15.3509 11.3667 15.4733 11.1217 15.7182C10.8768 15.9632 10.7542 16.2572 10.7539 16.6005C10.7538 16.9436 10.8761 17.2376 11.1211 17.4825ZM4.70435 11.996C4.70444 11.8491 4.76034 11.6999 4.87206 11.5882C4.98378 11.4765 5.12248 11.4211 5.27314 11.4218L18.7591 11.4232C18.91 11.4225 19.0474 11.4777 19.1611 11.5895C19.2749 11.7007 19.3328 11.8491 19.3328 11.996C19.3328 12.1429 19.277 12.2922 19.1652 12.4039C19.0535 12.5156 18.9148 12.5709 18.764 12.5698H5.24806C5.09617 12.5698 4.95684 12.5142 4.8361 12.3831C4.71835 12.2518 4.70444 12.1043 4.70435 11.996Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

const maskStyle: CSSProperties = {
  maskType: 'alpha',
};
